import { createColumnInlineInput, createColumnInput } from "../../../../../../components/table/c-table.logic";
import i18n from "../../../../../../i18n";
import { createLoading } from "../../../../../../utils/loading";
import store from "../../../../../../store";
import lodash from "lodash";
import { conditionFormChecker } from "../../../../../../utils/form";

export const { isLoading, setIsLoading } = createLoading();
export const actionPrefix = "resource/v1/transaction/cancelSequestrateProduct";
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];

    columns.push(
        createColumnInput({
            title: () => i18n.global.t("views.request.cancelSequestrateProductInfo.tradeNameTh"),
            dataIndex: "refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.cancelSequestrateProductInfo.refHazObject"),
            dataIndex: "refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
            align: "center"
        }),
        createColumnInlineInput({
            title: () => i18n.global.t("model.cancelSequestrateProduct.regNo"),
            dataIndex: "regNo",
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ key }) =>
                lodash.merge({ disabled: viewOnly }, conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } }))
        }),
        createColumnInlineInput({
            title: () => i18n.global.t("model.cancelSequestrateProduct.samplingNo"),
            dataIndex: "samplingNo",
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ key }) =>
                lodash.merge({ disabled: viewOnly }, conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } }))
        }),
        createColumnInlineInput({
            title: () => i18n.global.t("model.cancelSequestrateProduct.analysisResult"),
            dataIndex: "analysisResult",
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ key }) =>
                lodash.merge({ disabled: viewOnly }, conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } }))
        }),
        createColumnInlineInput({
            title: () => i18n.global.t("model.cancelSequestrateProduct.remark"),
            dataIndex: "remark",
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ key }) =>
                lodash.merge({ disabled: viewOnly }, conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } }))
        }),
    );
    return columns;
}
